import { useParams } from "react-router-dom";
import { PageHeader, Card } from "../components/UI";
import { Hammer } from "lucide-react";

export default function Placeholder({ title }) {
  const { name } = useParams();
  const label = title || decodeURIComponent(name || "Module");
  return (
    <div>
      <PageHeader title={label} />
      <Card className="p-12 text-center" data-testid="placeholder-module">
        <div className="mx-auto mb-4 h-14 w-14 rounded-2xl bg-[#F5F2EB] flex items-center justify-center text-[#7B6157]">
          <Hammer size={24} />
        </div>
        <h2 className="font-heading text-lg font-bold text-[#3E2723]">{label} is coming in a later phase</h2>
        <p className="mt-2 text-sm text-[#6D4C41] max-w-md mx-auto">
          This module is part of the Cocoa EHR roadmap and will be built in an upcoming phase. The navigation shell is in place so the full workflow stays familiar.
        </p>
      </Card>
    </div>
  );
}
